<template>
  <div class="container">
    <div class="title">
      <a href="javascript:void(0);" class="back_btn" @click.prevent="closePage()">
        <img src="@/assets/images/close.svg" />
      </a>
      <span>Cookie Policy</span>
      <router-link to="/index">
        <img src="@/assets/images/logo_header.png" alt="Logo" class="logo" />
      </router-link>
    </div>
    <div class="content">
      <p class="date">Effective Date: 2025/8/6</p>
      <p>
        This policy aims to inform you about how JoyJobs (hereinafter referred to as "we/our") uses Cookies and
        similar technologies (such as local storage, pixel tags, etc.) and to protect your personal information and
        privacy rights. Please read this policy carefully to understand our practices before choosing to continue using
        our services.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">1. What is a Cookie?</p>
      <p>
        A Cookie is a small text file placed on your device (computer, mobile phone, tablet, etc.) by us or third-party
        service providers when you visit our website. It is used to record information such as your browsing
        preferences, login status, and operational behaviors to enhance your user experience.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">2. Types and Purposes of Cookies</p>
      <p>
        We use the following types of Cookies: <br />
        <span class="label"><span class="circle"></span>Necessary Cookies</span> - Ensure the normal operation of core
        website functions (e.g., maintaining login status, resume submission, job application processes).<br />
        <span class="label"><span class="circle"></span>Functional Cookies</span> - Enhance user experience (e.g.,
        remembering your language preferences, resume filling progress, frequently used search criteria).<br />
        <span class="label"><span class="circle"></span>Analytical Cookies</span> - Used for website traffic statistics
        and user behavior analysis (e.g., page stay time, click-through rate, popular job types) to help us optimize
        website performance.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">3. Specific Use Scenarios of Cookies</p>
      <p>
        We use Cookies in the following scenarios to ensure the convenience and personalization of our services:<br />
        <span class="label"><span class="circle"></span>Login and Authentication</span> - Remember your login status to
        avoid repeated account password entry. <br />
        <span class="label"><span class="circle"></span>Resume Management</span> - Save your resume filling progress and
        favorite jobs.<br />
        <span class="label"><span class="circle"></span>Website Optimization </span>- Analyze user access paths to
        improve page loading speed and function layout.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">4. User Rights to Manage Cookies</p>
      <p>
        You have the right to manage Cookies according to your needs. You can disable or delete Cookies through browser
        settings, but please note that disabling Necessary Cookies may affect the use of core website functions (e.g.,
        login, job application).
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">5. Data Security and Protection</p>
      <p>
        We commit to protecting the security of personal information in Cookies through the following measures:<br />
        <span class="circle"></span>Transmission: Transmit Cookie data via HTTPS protocol to prevent mid-transmission
        leakage. <br />
        <span class="circle"></span>Access Control: Strictly restrict internal personnel's access to Cookie data; only
        authorized employees can process it. <br />
        <span class="circle"></span>Regular Audits: Conduct at least one security audit per year to identify and address
        risks in Cookie usage.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">6. Changes to the Policy and Notifications</p>
      <p>
        If this policy changes, we shall notify you in the following ways: <br />
        <span class="circle"></span>Send a change notice to the email address you provided during registration. <br />
        <span class="circle"></span>The revised policy shall take effect from the date of announcement, and continued
        use of our services shall be deemed as consent to the changes.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">7. Contact Us</p>
      <p>
        If you have any questions or suggestions about this policy, please contact us via:
        <a class="contact_email">hello@joylanders.com</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const closePage = () => {
  // window.close() 只能关闭 window.open 打开的窗口，直接从首页进入时会被浏览器静默拦截
  // 优先返回上一页，没有历史记录则跳首页
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/index');
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 850px;
  padding: 50px;
  margin: 50px auto;
  .back_btn {
    position: absolute;
    left: 20px;
    top: 10px;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #05644f;
    .logo {
      float: right;
      width: 230px;
      height: auto;
    }
  }
  .content {
    font-size: 14px;
    line-height: 24px;
    color: #3d3d3d;
    .date {
      font-size: 14px;
      color: #05644f;
      margin-bottom: 20px;
    }
    .sub_title {
      font-size: 24px;
      font-weight: 500;
      margin-top: 20px;
    }
    .content_divider {
      margin: 30px 0;
      background: #fff;
    }
    a {
      color: #0256ff;
      text-decoration: none;
    }
    .label {
      font-weight: 700;
    }
    .circle {
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #3d3d3d;
      border-radius: 50%;
      margin-right: 8px;
      vertical-align: middle;
    }
    .contact_email {
      color: #3d3d3d;
      font-weight: bold;
    }
  }
  // 手机端适配（≤640px）：固定 850px 容器在手机上横向溢出，logo 与关闭按钮跑出屏幕
  @media (max-width: 640px) {
    position: relative;
    box-sizing: border-box;
    width: auto;
    padding: 56px 16px 32px;
    margin: 0 auto;
    .back_btn {
      position: absolute;
      left: 12px;
      top: 14px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .title {
      font-size: 20px;
      margin-bottom: 16px;
      .logo {
        width: 120px;
      }
    }
    .content {
      font-size: 13px;
      line-height: 21px;
      word-break: break-word;
      .date {
        margin-bottom: 14px;
      }
      .sub_title {
        font-size: 18px;
        margin-top: 16px;
      }
      .content_divider {
        margin: 20px 0;
      }
      .content_ul {
        padding-left: 18px;
      }
    }
  }
}
</style>
